import { z } from "zod";

export const forgetPasswordSchema = z.object({
    email: z.string()
        .min(1, "errors.emailRequired")
        // .email("Invalid email address")
        .email("errors.invalidEmail"),
});
